import { ProfKindCodesEnum } from 'APIPackage/DictionariesModule/enums/ProfKindCodesEnum';

import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';

interface IMarkedField {
  appendShowMarkCondition?: (values: IKnmForm) => boolean;
}

export const isFieldRequiredForProfVisitStatusTypeCarriedOut = (
  fieldName: string | undefined,
  values: IKnmForm,
): boolean => {
  const idRegex = /\[\d+]/gi;
  const fieldNameTemplate = fieldName?.replaceAll(idRegex, '[{id}]');

  if (!fieldNameTemplate || !fieldsRequiredForProfVisitStatusTypeCarriedOut[fieldNameTemplate]) {
    return false;
  }

  const markedField = fieldsRequiredForProfVisitStatusTypeCarriedOut[fieldNameTemplate];

  return !markedField.appendShowMarkCondition || markedField.appendShowMarkCondition(values);
};

const fieldsRequiredForProfVisitStatusTypeCarriedOut: Record<string, IMarkedField> = {
  location: {
    appendShowMarkCondition: values => !values.location && !(values.manualAddress && values.region && values.notInFIAS),
  },
  interactionCategory: {
    appendShowMarkCondition: values => !values.interactionCategory,
  },
  objectsPm: {
    appendShowMarkCondition: values => !values.objectsPm || values.objectsPm.length === 0,
  },
  eventsPm: {
    appendShowMarkCondition: values => {
      const isTypeCodePP = values.pmType?.code === ProfKindCodesEnum.PP;
      const isRefusalImpossible = values.reasonsPm?.[0]?.reason?.flagProfvizit;

      if (isTypeCodePP && !isRefusalImpossible) {
        return false;
      }

      return !values.eventsPm || values.eventsPm.length === 0;
    },
  },
  requirementsNpa: {
    appendShowMarkCondition: values => !values.requirementsNpa || values.requirementsNpa.length === 0,
  },
  inspectorsErknm: {
    appendShowMarkCondition: values => !values.inspectorsErknm || values.inspectorsErknm.length === 0,
  },
};
